<template>
  <b-col
    v-if="showType == 'form-builder'"
    class="col column-container"
    :class="selectedElementControlId == id ? 'column-container-selected' : ''"
    :style="properties.style"
    @click.stop.prevent="setSelected"
    :cols="properties.cols || cols"
  >
    <div class="">
      <slot></slot>
    </div>
  </b-col>
  <b-col
    v-else-if="showType == 'form-submitter' || showType == 'e-form'"
    class="mt-2 col"
    :class="properties.cols || cols ? '' : 'custom-col'"
    :style="
      superComputeFormSubmitterValue({
        elementId: this.id,
        property: 'style',
        value: properties.style,
        defaultValue: '',
        form: this.form
      })
    "
    :cols="12"
    :md="properties.cols || cols"
  >
    <div class="">
      <slot></slot>
    </div>
  </b-col>
  <b-col
    v-else-if="showType == 'form-viewer'"
    :style="
      superComputeFormSubmitterValue({
        elementId: this.id,
        property: 'style',
        value: properties.style,
        defaultValue: '',
        form: this.form
      })
    "
    class="column-container-viewer col"
    :class="componentsIdSuffix ? 'mt-2' : ''"
    :cols="12"
    :md="properties.cols || cols"
  >
    <div class="">
      <slot></slot>
    </div>
  </b-col>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  name: "ColumnV1",
  props: [
    "properties",
    "showType",
    "id",
    "form",
    "formId",
    "componentsIdSuffix",
    "cols"
  ],
  methods: {
    setSelected() {
      this.$emit("set-selected");
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm[this.id]
        ? this.computedPropertiesForm[this.id][property]
          ? this.computedPropertiesForm[this.id][property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const style = this.superComputeFormSubmitterValue({
        elementId: this.id,
        property: "style",
        value: this.properties.style,
        defaultValue: "",
        form: {
          ...(this.form ? this.form : this.stateForm),
          showType: "form-viewer"
        }
      });
      return `<div class="column-container-viewer col col-12 ${
        this.properties.cols || this.cols
          ? "col-md-" + (this.properties.cols || this.cols)
          : ""
      } ${this.componentsIdSuffix ? "mt-2" : ""} ${
        this.properties.cols || this.cols ? "" : "custom-col"
      }" style="${style}"><div class=""><slot></slot></div></div>`;
    }
  },
  computed: {
    ...mapGetters("formSubmitter", ["superComputeFormSubmitterValue"]),
    ...mapState("formBuilder", {
      forms: state => state.form
    }),
    ...mapState("formSubmitter", {
      computedPropertiesForm: state => {
        return state.form.computedProperties;
      },
      stateForm: state => {
        return state.form;
      }
    }),
    selectedElementControlId() {
      return this.forms[this.formId].selectedElementControlId;
    }
  }
};
</script>

<style scoped>
.column-container {
  position: relative;
}
.column-container-viewer {
  word-break: break-all;
}
@media (min-width: 768px) {
  .custom-col {
    flex-basis: 0 !important;
    flex-grow: 1 !important;
    max-width: 100% !important;
  }
}
</style>
